<template>
    <STextArea :name="fieldName"
               :input-data="paragraphText"
               :namespace="namespace"
               :key="namespace"
    ></STextArea>
</template>

<script>
import PopulationBoilerplate from '@/views/Admin/Config/Population/Fields/PopulationBoilerplate';
import STextArea from '@/views/Common/Input/STextArea';

export default {
    components: { STextArea },
    mixins: [ PopulationBoilerplate ],

    data() {
        return {
            paragraphText: '',
        };
    },

    methods: {
        loadFieldData() {
            if (this.population) {
                this.paragraphText = this.population.paragraphText;
            }

            this.setFieldData();
        },

        setFieldData() {
            this.fieldData = {
                paragraphText: this.paragraphText,
            };

            this.storeFieldData();
        }
    },
};
</script>
